var Ips = {
  ip1: "https://fix.allscs.cn/jhh",
  // ip1:"https://fixtest.hohofast.com/jhh"
  // ip1: "http://localhost:8089",
}
module.exports = { Ips }


// WEBPACK FOOTER //
// ./src/config/ip.js